<template>
    <div>
        <!-- Alert - Login required -->
        <div class="row" v-if="loginDesc">
            <div class="col-sm-12">
                <ep-banner class="mb-6">
                    <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                    <span v-if="settingsLogin && settingsLogin.allow_create">{{ trans('online_booking.need_login') }}</span>
                    <span v-else>{{ trans('online_booking.need_login_no_create') }}</span>
                </ep-banner>
            </div>
        </div>

        <!-- Alert - Login Description -->
        <div class="row" v-if="loginDesc">
            <div class="col-sm-12">
                <div class="jumbotron-login m-b-20">
                    <span v-sanitize-html="loginDesc"></span>
                </div>
            </div>
        </div>

        <transition-group name="slideUp">
            <choose-login-or-signup
                key="choose-login-or-signup"
                v-show="loginSignupFlow == 'chooseLoginOrSignup' && settingsLogin && settingsLogin.allow_create">
            </choose-login-or-signup>
            <login key="login" v-show="loginSignupFlow == 'login'" class="row"></login>
            <login-code key="login-code" v-show="loginSignupFlow == 'loginCode'" class="row"></login-code>
            <choose-login-user
                :choose-from-login="chooseFromLogin"
                key="choose-login-user"
                v-show="loginSignupFlow == 'chooseLoginUser'"
                class="row">
            </choose-login-user>
            <sign-up key="signup" v-show="loginSignupFlow == 'signUp'" class="row"></sign-up>
        </transition-group>
    </div>
</template>

<script>
import Login from '@/online_booking/new/components/Login.vue';
import LoginCode from '@/online_booking/new/components/LoginCode.vue';
import ChooseLoginUser from '@/online_booking/new/components/ChooseLoginUser.vue';
import ChooseLoginOrSignup from '@/online_booking/new/components/ChooseLoginOrSignup.vue';
import SignUp from '@/online_booking/new/components/SignUp.vue';

export default {
    name: 'LoginFlow',

    props: {
        loginDesc: String,
        settingsLogin: Object,
        loginSignupFlow: String,
        chooseFromLogin: Boolean,
    },

    components: {
        Login,
        LoginCode,
        ChooseLoginUser,
        ChooseLoginOrSignup,
        SignUp,
    },
}
</script>
